// extracted by mini-css-extract-plugin
export default {"root":"asoNlT","rtl":"h0bWF1"};